import { apiServer } from '../settings'
import { getToken } from './token'
import createLog from '../utils/create-log';

const decrementBalance = (userGuid, userAuthorization, game, guid, type, amount, done) => {
    if (!userGuid) return done('missing userGuid')
    if (!userAuthorization) return done('missing userAuthorization')
    if (!game) return done('missing game')
    if (!guid) return done('missing guid')
    if (!type) return done('missing type')
    if (!amount) return done('missing amount')

    const headers = new Headers({
        Authorization: 'Bearer ' + getToken(),
        'Content-Type': 'application/json',
    })

    const options = {
        method: 'POST',
        headers,
        mode: 'cors',
        cache: 'default',
        body: JSON.stringify({
            type,
            amount,
            log: createLog(userGuid, userAuthorization, game, `decrement balance ${guid} ${type} ${amount}`),
        }),
    }

    const url = `${apiServer}/decrement-balance?game=${game}&guid=${guid}`

    fetch(url, options)
        .then(response => {
            return response.json()
        })
        .then(response => {
            if (response.success === false) return done(response.err)
            if (response.success === true) return done(null,response.updatedBalance)
            if (!response.success) return done('response without success true|false')
        })
        .catch(error => {
            console.error('Error:', error)
            done(error.message)
        })
}

export default decrementBalance
